import {styled} from "styled-components";
import {colorPalette} from "../styles/colorPalette";
import {radius, FlexCenterStyle, fontWeight, fontSize, ELLIPSIS, baseDistance, zIndex} from "../styles/styles";

export const LineStyled = styled.div<{$height?: number; $width?: number}>`
	height: ${(props) => (props.$height ? `${props.$height}px` : "40px")};
	width: ${(props) => (props.$width ? `${props.$width}px` : "2px")};
	background-color: ${colorPalette.blueGray.c200Light};
`;

export const ProjectNameStyled = styled.div<{$isInSettingsView: boolean}>`
	${FlexCenterStyle};
	gap: ${baseDistance.sm};
	position: relative;
	margin-left: ${(props) => (props.$isInSettingsView ? "216px" : "16px")};
	font-weight: ${fontWeight.bold};
	font-size: ${fontSize.lg};
	line-height: 24px;
	z-index: ${zIndex.notification};
	min-width: 172px;
`;

export const PortfolioNameStyled = styled.div<{$label?: string}>`
	${ELLIPSIS}
	width: 172px;
	flex: 1;
	word-break: normal;
	padding-right: ${baseDistance.sm};
	cursor: default;
`;

export const ProjectNameDropDownStyled = styled.div`
	display: flex;
	padding: 0 ${baseDistance.xs};
	height: 24px;
	border-radius: ${radius.sm};
	justify-content: flex-start;
	gap: ${baseDistance.sm};
	align-items: center;
	width: 100%;

	&:hover {
		background-color: ${colorPalette.blueGray.c200Light};
	}

	.projectTopBar {
		width: 140px;
		display: flex;
		align-items: center;
		overflow: hidden;
	}

	.projectNavBar {
		display: flex;
		align-items: center;
		overflow: hidden;
		width: 100%;
	}

	.projectNameTopBar {
		min-width: 172px;
		flex: 1;
		${ELLIPSIS};
		word-break: break-all;
		padding-right: ${baseDistance.sm};
	}

	.projectNameNavBar {
		flex: 1;
		${ELLIPSIS};
		padding-right: ${baseDistance.md};
		font-size: ${fontSize.md};
		font-weight: ${fontWeight.bold};
	}

	.DropdownV5 {
		border-radius: 10px;
		max-height: 288px;

		li {
			height: 40px;
		}
	}
`;

export const ProjectNameIconsStyled = styled.div`
	${FlexCenterStyle};
	pointer-events: auto;
	position: relative;
	width: 12px;
	height: 12px;
	margin-left: auto;
	cursor: pointer;

	&.dockIcon {
		width: 28px;
		height: 28px;
		fill: transparent;
		border-radius: ${radius.xs};

		.icon {
			width: 24px;
			height: 24px;
		}
	}
`;
